'use client';

import ImageViewer, {
	type IProps as ImageViewerProps,
} from 'components/collection/image-viewer';
import trackClickButton from 'lib/analytics/trackClickButton';
import { collectionImageToImageViewerImage } from 'helpers/images';
import type { ICollectionImage } from '@metmuseum/types';

export default function CollectionObjectImageViewer({
	title,
	objectID,
	vntanaAssets,
	isRightToLeft,
	images,
	printUrl,
}: CollectionObjectImageViewerProps) {
	const viewerImages = images.map(collectionImageToImageViewerImage);
	const handleAnalyticsEvent = (event) => {
		trackClickButton({
			buttonClicked: event.type,
			contentType: 'Collection Objects',
			contentBlock: 'CTA',
			contentName: title,
			objectId: objectID,
		});
	};

	return (
		<ImageViewer
			vntanaAssets={vntanaAssets}
			isRightToLeft={isRightToLeft}
			title={title}
			objectID={objectID}
			images={viewerImages}
			printUrl={printUrl}
			onAnalyticsEvent={handleAnalyticsEvent}
		/>
	);
}

interface CollectionObjectImageViewerProps extends Omit<
	ImageViewerProps,
	'images' | 'onAnalyticsEvent'
> {
	images: ICollectionImage[];
}
